import { VideoHTMLAttributes } from 'react';
import Asset from '@/components/asset';

export default function Video(props: VideoHTMLAttributes<HTMLVideoElement>) {
    return <Asset element={'video'} {...props} />;
}
